import React from 'react';
import { ChecklistIconProps, ChecklistIconView } from './ChecklistIcon.styles';

export const ChecklistIcon: React.FC<ChecklistIconProps> = ({
  color = 'black',
  size = 24,
  strokeWidth = 1,
  className,
}) => {
  return (
    <ChecklistIconView
      color={color}
      size={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
};

export default ChecklistIcon;
